export const extractNothing = () => {
  return;
};
